<template>
  <div class="layout-footer full-content">
    <div class="layout-link center-content">
      <div class="layout-link-piece">
        <div class="link-piece-title">友情链接</div>
        <div class="link-piece-list">
          <a
            href="http://fao.hangzhou.gov.cn"
            target="_blank"
            class="link-piece-item"
            >杭州市外事办公室</a
          >
          <a
            href="https://www.zjzwfw.gov.cn/zjservice-fe/#/home?siteCode=330000000000"
            target="_blank"
            class="link-piece-item"
            >浙江政务服务网</a
          >
          <a
            href="https://www.idcpc.org.cn"
            class="link-piece-item"
            target="_blank"
            >中共中央对外联络部</a
          >
          <a
            href="https://www.cpaffc.org.cn"
            class="link-piece-item"
            target="_blank"
            >中国人民对外友好协会</a
          >
        </div>
      </div>
      <div class="layout-link-piece">
        <div class="link-piece-title">联系方式</div>
        <div class="link-piece-list">
          <a href="tel:0571-88385447" class="link-piece-item"
            >0571-88385447（会议服务）</a
          >
          <a href="tel:0571-88380340" class="link-piece-item"
            >0571-88380340（出入境服务）</a
          >
          <a href="tel:0571-88382563" class="link-piece-item"
            >0571-88382563（翻译服务）</a
          >
          <a href="tel:0571-87008253" class="link-piece-item"
            >0571-87008253（签证服务）</a
          >
        </div>
      </div>
      <div class="layout-link-piece">
        <div class="link-box">
          <div class="link-piece-title">地址：</div>
          <div class="link-box-text">
            杭州市拱墅区王马东路92号武林之星博览中心4号楼3F
          </div>
        </div>
        <div class="link-box">
          <div class="link-piece-title">邮箱：</div>
          <div class="link-box-text">
            <a href="mailto:guojiaozhongxin1@163.com" class="link-box-a">
              guojiaozhongxin1@163.com
            </a>
          </div>
        </div>
        <div class="link-box">
          <div class="link-piece-title">电话：</div>
          <div class="link-box-text">
            <a href="tel:0571-88382653" class="link-box-a">0571-88382653</a>
            /
            <a href="tel:0571-88386328" class="link-box-a">0571-88386328</a>
          </div>
        </div>
      </div>
      <div class="layout-link-piece link-route">
        <RouterLink
          :to="{ name: n.routeName }"
          class="layout-link-route"
          v-for="(n, i) in navs"
          :key="i"
          >{{ n.title }}</RouterLink
        >
      </div>
    </div>
    <div class="layout-concat">
      <div class="layout-concat-box center-content">
        <div class="layout-concat-logo"></div>
        <div
          class="layout-record flex-grow flex-box justify-center"
          style="gap: 1em"
        >
          杭州国际会议外事通
          <a href="https://beian.miit.gov.cn">浙ICP备2022008259号-2</a>
        </div>
        <!--        <div class="layout-protocol">网站声明 | 隐私政策</div>-->
        <!--        <div class="layout-share">-->
        <!--          <div class="layout-share-title">分享至：</div>-->
        <!--          <div class="layout-share-item" v-for="(s, i) in shareList" :key="i">-->
        <!--            <img :src="s.icon" class="layout-share-icon" />-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts" name="LayoutFooter">
defineProps(["navs"]);
const shareList = [
  {
    icon: require("@/assets/image/wechat.png"),
    link: "",
  },
  {
    icon: require("@/assets/image/qq.png"),
    link: "",
  },
  {
    icon: require("@/assets/image/sina.png"),
    link: "",
  },
];
</script>
<style lang="less">
.layout-footer {
  background-color: #f9f9f9;
}
.layout-link {
  display: flex;
  padding: 48px 240px;
}
.layout-link-piece {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  color: var(--black);
  letter-spacing: -0.5px;
  line-height: 1.25;
  &.link-route {
    flex: none;
    padding-left: 100px;
    width: 280px;
  }
}
.link-piece-title {
  padding: 10px 0;
  font-size: 18px;
  font-weight: 600;
}
.link-piece-list {
  opacity: 0.6;
}
.link-piece-item {
  display: block;
  margin-top: 20px;
  font-size: 16px;
  color: inherit;
}
.link-box {
  &:not(:first-of-type) {
    margin-top: 10px;
  }
}
.link-box-text {
  margin-top: 10px;
  padding: 10px 0;
  color: rgba(0, 0, 0, 0.6);
  font-size: 16px;
}
.link-box-a {
  color: inherit;
}
.layout-link-route {
  padding: 10px 0;
  color: var(--black);
  font-size: 16px;
  font-weight: 600;
}
.layout-concat {
  background-color: #f2f2f2;
  color: #4f4b4c;
}

.layout-concat-box {
  display: flex;
  align-items: center;
  padding: 0 300px 0 250px;
  height: 76px;
}
.layout-concat-logo {
  width: 118px;
  height: 66px;
  background: url(../assets/image/home/logo-color.png) center / contain
    no-repeat;
}
.layout-record {
  margin-left: 68px;
  width: 544px;
  font-size: 13px;
}
.layout-protocol {
  flex: 1;
  min-width: 0;
  font-size: 14px;
}
.layout-share {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #111;
}
.layout-share-item {
  margin-left: 24px;
  width: 26px;
  height: 26px;
  line-height: 1;
}
.layout-share-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
